const sprintf = require('sprintf-js').sprintf

/**
 *
 * @param count Number
 * @param plural String
 * @param singular String
 * @param none String
 * @returns String
 */
const plural = (count, plural, singular = plural, none = singular) => {
    if (count > 1) {
        return sprintf(plural, count)
    } else if (count === 1) {
        return sprintf(singular, count)
    }

    return none ? sprintf(none, count) : sprintf(singular, count)
}

module.exports = { plural, sprintf }



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/std/string.js